import { TKeys } from './types'

export const de_de: Record<TKeys, string> = {
    ...require('./en-en').en_en, // TODO
    // SCREENS
    // General
    loading: 'Lädt...',
    // SignIn
    signin_title: 'Anmelden',
    signin_redirect_title: 'Überprüfen Sie Ihre Anmeldedaten',
    psw_placeholder_redirect: "Passwort bestätigen",
    psw_placeholder: 'Passwort bestätigen',
    email_placeholder: 'E-Mail-Adresse',
    language: 'Sprache',
    forgot_password: 'Passwort vergessen?',
    signup_hint: 'Kein Konto? Registrieren Sie sich',
    btn_signin: 'Anmelden',
    // Intro
    // N-Ary sort
    my_profile: 'Meine Vorlieben',
    btn_submit: 'Absenden',
    btn_finish: 'Abschluss',
    hint_undo: 'Sind Sie sicher, dass Sie Ihre letzte Aktion rückgängig machen möchten?',
    // Global screen
    tip_quit: 'Sind Sie sicher, dass Sie aufhören möchten?',
    // State screen // Tell us, what is your ideal work environment?
    intro_title: 'Glück ist der Schlüssel zum Erfolg',
    intro_body: `Wenn Sie das tun, was Sie lieben, und das Team, mit dem Sie zusammenarbeiten, werden Sie in Ihrem beruflichen Leben erfolgreich sein.`,
    howto1_title: `Sie werden zwei Aussagen sehen

    Klicken Sie auf diejenige, die Sie bevorzugen

    Dies wird nur 12 Minuten in Anspruch nehmen.`,
    howto1_body: `Sie sollten dieses Test in einem ruhigen Umfeld durchführen.`,
    award1_title: 'Gut gemacht',
    award1_body: `Am Anfang der folgenden Liste finden Sie, was Sie als wichtigste Dinge in Ihrem idealen Arbeitsumfeld betrachten. Wenn Sie möchten, können Sie die Reihenfolge der Aussagen durch Ziehen und Ablegen ändern.`,
    award2_title: 'Sie sind mehr als die Hälfte durchgekommen',
    award2_body: `An der Spitze der folgenden Liste stehen die Elemente, die Ihrer Meinung nach in Ihrem idealen Arbeitsumfeld am wichtigsten sind. Sie können die Reihenfolge der Aussagen ändern, indem Sie sie verschieben.`,
    award3_title: 'Gratulation zum dritten Teil',
    award3_body: `An der Spitze der folgenden Liste stehen die Elemente, die Ihrer Meinung nach in Ihrem idealen Arbeitsumfeld am wichtigsten sind. Sie können die Reihenfolge der Aussagen ändern, indem Sie sie verschieben.`,
    howto2_title: 'Und jetzt die letzten Fragen - ±2 Minuten',
    howto2_body: `Können Sie die folgenden Aussagen von der wichtigsten (oben) bis zur unwichtigsten (unten) einordnen?`,
    title_rank: 'In meinem **IDEALEN** Arbeitsumfeld,',
    subtitle_rank_2: 'was wichtig ist ...',
    subtitle_rank_n: 'Wo würden Sie die folgende Aussage platzieren?',
    hint_reorder: 'Reihen Sie nach Bedarf um, von wichtigsten zu unwichtigsten',
    hint_overview: 'Klicken Sie unten, um die Zusammenfassung zu sehen',
    hint_profile: 'Meine aktuellen Vorlieben',
    hint_place_below: 'Platzieren Sie die Aussage unten',
    title_rank_bucket: 'Sehr letzte Vergleiche',
    subtitle_rank_best: 'Diesmal ist die wichtigste für Sie?',
    subtitle_rank_least: 'Die unwichtigste für Sie ist?',
    subtitle_rank_reorder: 'Reihen Sie von wichtigsten zu unwichtigsten um',
    title_thanks: 'Gut gemacht',
    hint_thanks: 'Ihre Vorlieben wurden erfolgreich abgeschickt',
    title_error: 'Wir können Ihre Daten nicht senden',
    hint_error: 'Bitte versuchen Sie es später erneut ...',
    hint_error_validation: 'Ein Validierungsfehler trat auf, bitte versuchen Sie es später erneut',
    hint_error_dup: `Sie haben bereits einen vorherigen Bericht abgeschickt.`,
    hint_confirm_round: 'Sind Sie sicher, dass Sie dieses Ranking bestätigen wollen?',
    retry_btn: 'Wiederholen',
    btn_to_overview: 'ÜBERBLICK',
    btn_to_bucket_x: 'KORB',
    btn_to_params: 'PARAMETER',
    btn_open: 'ÖFFNEN',
    btn_start: 'STARTEN',
    btn_confirm: 'BESTÄTIGEN',
    // btn_next: 'NEXT',
    btn_next: '>',
    btn_next_str: 'WEITER',
    btn_next_round: 'NÄCHSTER RUND',
    // btn_prev: 'PREV',
    btn_prev: '<',
    btn_cancel: 'ABBRECHEN',
    // btn_back: 'BACK',
    btn_back: '<',
    btn_download: 'Herunterladen Sie Ihren Bericht',
    btn_quit: 'ABBRECHEN',
    // Comparisons
    pick_best: 'Die wichtigste für Sie ist?',
    pick_worst: 'Die unwichtigste für Sie ist?',
    vs: 'ODER',
    // UI elements
    round: 'RUND',
    stm: 'AUSSAAGE',
    bucket: 'KORB',
    axis_y: 'Anzahl der Aussagen',
    tip_saved: 'GESPEICHERT',
    top_scale_hint: 'Die **WICHTIGSTE**',
    bottom_scale_hint: 'Die **UNWICHTIGSTE**',
    pick_tip: 'Gewählt',
    how_to_binary_title: 'Anweisungen',
    // values
    samen: 'Zusammenarbeit',
    conf: 'Konformität',
    erken: 'Anerkennung',
    zorg: 'Sorgfalt',
    gelijk: 'Gleichheit & Ungleichheit',
    zelfsturing: 'Autonomie',
    macht: 'Macht',
    voorspelbaar: 'Vorhersehbarkeit',
    prestatie: 'Leistung',
    zelfontplooi: 'Selbstentwicklung',
    duurzaam: 'Nachhaltigkeit',
    integriteit: 'Integrität',
    innovatie: 'Innovation',
    daadkracht: 'Stärke',
    // 
    no_slug_error: 'Bitte stellen Sie sicher, dass Sie den richtigen Link folgten, wenn Sie dies tun, kontaktieren Sie den Administrator/Support',
    unknown_error: 'in unbekannter Fehler trat auf, bitte versuchen Sie es später erneut',
    invalid_credentials: 'Ungültige E-Mail/Passwort-Kombination',
    // 360
    // TLTM scale
    lvl0: 'Bitte wählen Sie',
    lvl1: 'Viel zu wenig',
    lvl2: 'Zu wenig',
    lvl3: 'Ein bisschen zu wenig',
    lvl4: 'Richtige Menge',
    lvl5: 'Ein bisschen zu viel',
    lvl6: 'Zu viel',
    lvl7: 'Viel zu viel',
    lvlx1: '-3',
    lvlx2: '-2',
    lvlx3: '-1',
    lvlx4: 'Richtige Menge',
    lvlx5: '+1',
    lvlx6: '+2',
    lvlx7: '+3',
    // SCALE 10 lvlSC10x
    lvlSC10x00: 'Bitte wählen Sie',
    lvlSC10x00e: '🤔',
    // 
    lvlSC10x0e: '😫',
    lvlSC10x0nps: 'Nie',
    lvlSC10x0: "Null",
    lvlSC10x1e: '😖',
    lvlSC10x1nps: 'MISSING',
    lvlSC10x1: "Extrem Schlecht",
    lvlSC10x2e: '😣',
    lvlSC10x2nps: 'MISSING',
    lvlSC10x2: "Sehr Schlecht",
    lvlSC10x3e: '😠',
    lvlSC10x3nps: 'MISSING',
    lvlSC10x3: "Unzureichend",
    lvlSC10x4e: '🙁',
    lvlSC10x4nps: 'MISSING',
    lvlSC10x4: "Schlecht",
    lvlSC10x5e: '😯',
    lvlSC10x5nps: 'MISSING',
    lvlSC10x5: "Mittelmäßig",
    lvlSC10x6e: '😐',
    lvlSC10x6nps: 'MISSING',
    lvlSC10x6: "Durchschnitt",
    lvlSC10x7e: '🙂',
    lvlSC10x7nps: 'MISSING',
    lvlSC10x7: "Gut",
    lvlSC10x8e: '😊',
    lvlSC10x8nps: 'MISSING',
    lvlSC10x8: "Sehr gut",
    lvlSC10x9e: '😃',
    lvlSC10x9nps: 'MISSING',
    lvlSC10x9: "Hervorragend",
    lvlSC10x10e: '😍',
    lvlSC10x10nps: 'Sicherlich',
    lvlSC10x10: "Makellos",
    howto_360_title: `Als Organisation accordieren wir großen Wert auf Werte, wir glauben, dass es wichtig ist zu wissen, was Sie wirklich glücklich macht in Ihrem Arbeitsumfeld.`,
    howto_360_body: `Dieses Fragebogen ist und bleibt anonym für Ihre Hierarchie, die nur die aggregierten Ergebnisse erhalten wird.`,
    // picker_360_title: "In weltem Maße finden Sie den folgenden Aussage in Ihrem aktuellen Arbeitsumfeld?",
    picker_360_title_workenv: "In meinem aktuellen Arbeitsumfeld …",
    picker_360_title_leadership: "Mein direkter Vorgesetzter …",
    nps_title: "Würden Sie jemanden empfehlen, hier zu arbeiten?",
    comment_title: 'Ein Kommentar hinzufügen',
    comment_placeholder: 'Wir danken Ihnen für jede konstruktive Rückmeldung zu dieser Aussage',
    comment_save: 'Speichern und schließen',
    comment_remaining: 'character(s) left',
    howto_workenv_title: 'And now, your work environment',
    howto_workenv_body: 'What about it ? Last questions, we promise!',
    howto_nps_title: "",
    howto_nps_body: "",
    // legacy_v2:
    btn_next_step: 'Weiter',
    to_assign: 'Zu verteilen',
    least_important: 'Am wenigsten wichtig',
    moderately_important: 'Mäßig wichtig',
    most_important: 'Am wichtigsten',
    ranker_title: 'Was ist dir in deinem idealen Job wichtig?',
    too_insufficient_warning: 'Diese Gruppe enthält zu wenige Aussagen',
    too_much_warning: 'Diese Gruppe enthält zu viele Aussagen',
    too_much_warning1: 'Du hast zu viele Aussagen den folgenden Gruppe(n) zugewiesen:',
    too_much_warning2: 'Klicke auf die Gruppe und ordne die Aussage(n) einer anderen Gruppe zu, bis die Verteilung korrekt ist',
    empty_bin: 'Diese Gruppe ist leer',
    further_ranking: 'Was ist dir in deinem idealen Job wichtig?',
    hint_modal_title: 'Stellen Sie sich Ihre ideale Arbeitsumgebung vor.',
    hint_modal_body1: 'Ordnen Sie 42 Aussagen über Ihre ideale Arbeitsumgebung von weniger wichtig bis am wichtigsten.',
    hint_modal_body2_left: 'links',
    hint_modal_body2_left_txt: 'die 11 Aussagen, die du am wenigsten wichtig findest',
    hint_modal_body2_right: 'rechts',
    hint_modal_body2_right_txt: 'die 11 Aussagen, die du am wichtigsten findest',
    hint_modal_body2_middle: 'mitte',
    hint_modal_body2_middle_txt: 'die 20 Aussagen, die du als mäßig wichtig empfindest',
    hint_modal_body3: 'Ziehen Sie jede Aussage per Drag & Drop in den Eimer, der am besten zu Ihnen passt',
    hint_modal_cta: 'Start',
    hint_top: 'Nach oben scrollen',
    hint_down: 'Nach unten scrollen',
    final_distribution_invalid_title: 'Die endgültige Verteilung ist ungültig',
    final_distribution_invalid_body: 'Es gibt {{v1}} Behälter mit zu vielen Aussagen und {{v2}} Behälter mit zu wenigen Aussagen',
    no_available_bins_warning: 'Keine verfügbaren Behälter für die zufällige Zuweisung - alle Behälter haben ihre maximale Kapazität erreicht',
    sort_middle_bucket_title: 'Möchten Sie den mittleren Eimer sortieren?',
    sort_middle_bucket_body: 'Dadurch wird der mittlere Eimer nach Wert sortiert.',
    reflect_current_view_title: 'Spiegelt dies Ihre aktuelle Ansicht wider?',
    reflect_current_view_sort_body: 'Wenn nicht, werden Sie aufgefordert, Ihre endgültige Rangfolge zu sortieren',
    yes: 'Ja',
    no: 'Nein',
    final_ranking: 'Endgültige Rangliste',
    example: 'Beispiel :',
}